import { Template } from '@templates/types'

interface State {
  loading: boolean
  templatesByFolder: Record<number, Template[]>
  templatesById: Record<number, Template>
}

export enum ActionType {
  TEMPLATES_LOADED = 'TEMPLATES_LOADED',
  DEFAULT_ACTION = 'DEFAULT_ACTION',
}

interface Action {
  type: ActionType
  payload: Template[]
}

const initialState: State = {
  loading: true,
  templatesByFolder: {},
  templatesById: {},
}

const defaultAction: Action = {
  type: ActionType.TEMPLATES_LOADED,
  payload: [],
}

export function Submissions(state = initialState, action: Action = defaultAction) {
  switch (action.type) {
    case ActionType.TEMPLATES_LOADED: {
      const templatesByFolder = action.payload.reduce((memo, temp) => {
        memo[temp.folder_id] ??= []

        const match = state.templatesById[temp.id]
        memo[temp.folder_id].push(match ? { ...match, ...temp } : temp)
        return memo
      }, {})

      // iterate through payload to spread existing matches first and then updated match.
      // This is to resolve inconsistency between the two API calls.
      // TODO: Map integrations by slug from location that sets templates_loaded.

      const templatesById: Record<number, Template> = action.payload.reduce((memo, item) => {
        const match = state.templatesById[item.id]
        if (!match) return { ...memo, [item.id]: item }

        // Spread existing item, since we may already have additional properties.
        // Since these templates are loaded from two different API calls, and consumed
        // in different components accessing different properties.
        return { ...memo, [item.id]: { ...match, ...item } }
      }, {})

      return {
        ...state,
        loading: false,
        templatesByFolder,
        templatesById,
      }
    }
    case ActionType.DEFAULT_ACTION:
    default:
      return state
  }
}
